import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden" data-id="element-122">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-navy-800 rounded-full blur-[120px] opacity-50 -z-10" data-id="element-123"></div>

      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-124">
        <div className="order-2 md:order-1" data-id="element-125">
          <FadeIn delay={0.1} data-id="element-126">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6" data-id="element-127">
              SUEÑO PROFUNDO <br data-id="element-128" />
              <span className="text-amber-500 text-3xl md:text-4xl lg:text-5xl" data-id="element-129">
                (SIN PASTILLAS)
              </span>
            </h1>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-130">
            <p className="text-xl md:text-2xl text-lavender-200 mb-8 leading-relaxed" data-id="element-131">
              Recupera el sueño profundo sin pastillas.
            </p>
            <p className="text-lg md:text-xl text-lavender-300 mb-8 leading-relaxed" data-id="element-132">
              Cómo lograr un sueño reparador de 7 horas para mayores de 50 años.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-133">
            <Button onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-134">
              Descargalo AHORA !!
            </Button>
            <p className="mt-4 text-sm text-lavender-300 flex items-center gap-2" data-id="element-135">
              <svg className="w-4 h-4 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-136">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-137" />
              </svg>
              Compra segura. Acceso instantáneo en PDF.
            </p>
          </FadeIn>
        </div>

        <div className="order-1 md:order-2 flex justify-center" data-id="element-138">
          <FadeIn delay={0.4} direction="left" data-id="element-139">
            <div className="relative" data-id="element-140">
              <div className="absolute -inset-4 bg-amber-500/20 blur-2xl rounded-full z-0" data-id="element-141"></div>
              <img src="https://cdn.magicpatterns.com/uploads/gyV8V8MwVnM4G2dy1xznwF/Portada_SuenoProfundoSP.png" alt="Sueño Profundo Cover" className="relative z-10 w-full max-w-md rounded-xl shadow-2xl transform -rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-142" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}